// extracted by mini-css-extract-plugin
export var defaultWrapper = "_fz-3";
export var downloadButton = "_fz-4";
export var fileContainer = "_fz-9 _fz-7";
export var fileContainerBase = "_fz-7";
export var fileContainerBaseSm = "_fz-a _fz-7";
export var fileContainerFixedHeight = "_fz-8 _fz-7";
export var fileContainerFixedHeightSm = "_fz-c _fz-a _fz-7";
export var fileContainerSm = "_fz-b _fz-a _fz-7";
export var fileInfo = "_fz-5";
export var fileInfoWidthRestricted = "_fz-6";
export var fileType = "_fz-1";
export var fileTypeName = "_fz-2";
export var fileTypeSm = "_fz-d _fz-1";
export var image = "_fz-0";
export var link = "_fz-f";
export var overflowEllipsis = "_fz-e";